import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import BookingCapList from '../../components/BookingCaps/BookingCapList';
import BookingCapToolbar, {
    CapSortKey,
} from '../../components/BookingCaps/BookingCapToolbar';

const EXPERIENCE_TYPES = [
    'All',
    'boat',
    'vehicle',
    'activity',
    'commercial',
    'property',
] as const;
const APPLIES_TO_OPTIONS = ['All', 'user', 'company'] as const;

const BookingCapPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const theme = useTheme();

    // ---- toolbar state ----
    const [query, setQuery] = useState('');
    const [experienceType, setExperienceType] = useState<string>('All'); // <- renamed
    const [appliesTo, setAppliesTo] = useState<string>('All');
    const [sortKey, setSortKey] = useState<CapSortKey>('nameAsc');

    const onClickGoBack = () => navigate(`/adminCentre/host`);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile || isIpad ? '100%' : '95%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Box sx={{ px: { xs: 2, md: 0 }, width: '100%' }}>
                <Grid sx={{ width: '100%', display: 'flex', mb: 1.5 }}>
                    <Typography
                        variant='h1'
                        sx={{
                            textAlign: 'left',
                            textTransform: 'uppercase',
                        }}
                    >
                        Booking Caps
                    </Typography>
                </Grid>

                {/* Toolbar */}
                <Box sx={{ mt: 0.5 }}>
                    <BookingCapToolbar
                        query={query}
                        onQueryChange={setQuery}
                        experienceType={experienceType}
                        onExperienceTypeChange={setExperienceType}
                        appliesTo={appliesTo}
                        onAppliesToChange={setAppliesTo}
                        appliesToOptions={Array.from(APPLIES_TO_OPTIONS)}
                        sortKey={sortKey}
                        onSortKeyChange={setSortKey}
                    />
                </Box>

                {/* List */}
                <Box sx={{ mt: 1.5, pb: 2 }}>
                    <BookingCapList
                        query={query}
                        experienceType={experienceType} // <- renamed
                        appliesTo={appliesTo}
                        sortKey={sortKey}
                    />
                </Box>

                {/* Back (hidden on small) */}
                <Grid
                    sx={{
                        height: '5%',
                        display: isMobile || isIpad ? 'none' : 'flex',
                    }}
                >
                    <CustomButton
                        onClick={onClickGoBack}
                        color='primary'
                        sx={{
                            marginLeft: '-8px',
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />
                        <Typography sx={{ fontSize: '12px', pl: '5px' }}>
                            Back
                        </Typography>
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    );
};

export default BookingCapPage;
